import "./loadingAnimationWhite.css";

function LoadingAnimationWhite() {
  return (
    <div className="lds-roller-white">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default LoadingAnimationWhite;
